<micro-select-combo #sel
              [placeholder]="placeholder"
              routerBase="mocs"
              valueField="value"
              [(id)]="mocId"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [requires]="requires()"
              [disabled]="disabled"
>
</micro-select-combo>
